import React from 'react';
import { connect } from 'react-redux';
import { Form, Upload, Icon,  Button, Radio, AutoComplete, message } from 'antd'
import UploadBoxFilesWrapper from './UploadBoxFiles.style';
import { searchReportTitles, uploadFile, setReportSearchResult } from '../../../redux/actions/Box/BoxActions';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const Option = AutoComplete.Option;

const props = {
  name: 'file',
  multiple: false,
  customRequest: ({file, onSuccess}) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  },
  beforeUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < 7.5;
    if (!isLt2M) {
        message.error('File must be smaller than 7.5MB!');
        return false;
    }
  }
};

class UploadBoxFilesForm extends React.Component {
  
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.setReportSearchResult([]);
  }
  
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if(values.type === 'report_pdf') {
          if(values.dragger.file.type !== 'application/pdf') {
            message.error('File must be a pdf!');
            return false;
          }
        }
        else if(values.type === 'me_sheet') {
          if(values.dragger.file.type !== 'text/csv') {
            message.error('File must be a csv!');
            return false;
          }
        }
        this.props.uploadFile(values);
      }
    });
  }
  
  render() {

    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    let report_titles = this.props.BOXREDUCER.search_reports_result.length && this.props.BOXREDUCER.search_reports_result.map(report => <Option value={report.id.toString()}>{report.title}</Option>);

    return(
      <UploadBoxFilesWrapper>
        <h3>Upload Box Files Here</h3>
        <Form onSubmit={this.handleSubmit}>

          <FormItem
            {...formItemLayout}
            label="Search Report Title"
          >
            {getFieldDecorator('report_id', {
              initialValue: [],
              rules: [
                { required: true, message: 'Please search and select a report title!' },
              ]
            })(
              <AutoComplete
                style={{ width: '100%' }}
                onSearch={(value) => this.props.searchReportTitles(value,'box')}
                placeholder="input here"
              >
                {report_titles}
              </AutoComplete>
            )}
          </FormItem>

          <FormItem
              {...formItemLayout}
              label="File Type"
            >
              {getFieldDecorator('type', {
                rules: [
                  { required: true, message: 'Please select a file type!' },
                ],
              })(
                <RadioGroup>
                  <RadioButton value={'report_pdf'}>PDF(Report)</RadioButton>
                  <RadioButton value={'me_sheet'}>CSV(ME Sheet)</RadioButton>
                </RadioGroup>
              )}
            </FormItem>
        
          <FormItem
            {...formItemLayout}
            label="Dragger"
          >
            <div className="dropbox">
              {getFieldDecorator('dragger', {
              })(
                <Upload.Dragger {...props}>
                  <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">File size should not exceed 7.5 MB</p>
                </Upload.Dragger>
              )}
            </div>
          </FormItem>

          <FormItem
            wrapperCol={{ span: 12, offset: 6 }}
          >
            <Button type="primary" htmlType="submit">Submit</Button>
          </FormItem>

        </Form>
      </UploadBoxFilesWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  searchReportTitles,
  uploadFile,
  setReportSearchResult
};

const UploadBoxFiles = Form.create()(UploadBoxFilesForm);

export default connect(mapStateToProps, mapDispatchToProps)(UploadBoxFiles);


// WEBPACK FOOTER //
// ./src/components/Box/UploadBoxFiles/UploadBoxFiles.js